<template>
  <div>
    <Upselling
      @cta-click="onClick"
      class="p-6 max-w-[460px] border shadow-lg rounded-10 border-slate-300 dark:border-zinc-700"
      data-testid="video-merge-modal-upselling"
      :header="header"
      :message="message"
      :cta="cta"
    />
  </div>
</template>
<script setup lang="ts">
import Upselling from '@/components/Upselling.vue';
import { useViewerTrack, TrackEvents } from '@/modules/viewer/composables/useViewerTrack';

const { trackItemOwner } = useViewerTrack();

defineProps<{
  header?: string;
  message: string[] | string;
  cta?: string;
}>();

const onClick = (e: MouseEvent) => {
  e.stopPropagation();
  e.preventDefault();

  trackItemOwner(TrackEvents.UPGRADE_CLICK).then(() => {
    window.location.assign('/account/plans');
  });
};
</script>
